import {documentToHtmlString, type Options} from '@contentful/rich-text-html-renderer'
import {BLOCKS} from '@contentful/rich-text-types'
import {Prose} from '@primer/react-brand'

import type {PrimerComponentProse} from '../../../schemas/contentful/contentTypes/primerComponentProse'

export type ContentfulProseProps = {
  component: PrimerComponentProse
  enableFullWidth?: boolean
}

export function ContentfulProse({component, enableFullWidth}: ContentfulProseProps) {
  const captionOption: Options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, next) => {
        // eslint-disable-next-line github/unescaped-html-literal
        return `<figcaption>${next(node.content)}</figcaption>`
      },
    },
  }

  const options: Options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: node => {
        const url = `https:${node.data.target.fields.file.url}`
        const altText = node.data.target.fields.description

        /* eslint-disable-next-line github/unescaped-html-literal --
         * Reason: Content sourced from Contentful is deemed trustworthy, thus the usual concerns over
         * unescaped HTML literals are mitigated in this context.
         */
        return `<img src="${url}" alt="${altText}" />`
      },
      [BLOCKS.EMBEDDED_ENTRY]: node => {
        const {quote, caption} = node.data.target.fields

        // quote and caption are both RichText fields
        const figureQuote = documentToHtmlString(quote)
        const figureCaption = documentToHtmlString(caption, captionOption)

        // eslint-disable-next-line github/unescaped-html-literal
        return `<figure><blockquote>${figureQuote}${figureCaption}</blockquote></figure>`
      },
    },
  }

  const htmlMarkup = documentToHtmlString(component.fields.text, options)

  return <Prose enableFullWidth={enableFullWidth} html={htmlMarkup} />
}

try{ ContentfulProse.displayName ||= 'ContentfulProse' } catch {}